import { CodeReviewerFeedbackSentiment } from 'src/components/conversation/src/internal/analytics';

export type FeedbackResponse = {
  status: 'OK' | 'FAILED';
  message: string;
};

export enum CodeReviewerFeedbackType {
  GENERATED_CONTENT = 'generated-content',
  UI = 'ui',
  SUGGESTION = 'suggestion',
  STUCK = 'stuck',
}

export type FeedbackData = {
  feedbackType?: CodeReviewerFeedbackType;
  feedbackDescription: string;
  allowContact?: boolean;
  sentiment: CodeReviewerFeedbackSentiment;
  hasCodeSuggestions?: boolean;
  prUrl: string;
};

export type CodeReviewerTextSubmissionState =
  | 'hidden'
  | 'pending'
  | 'submitted';
